import React, { ReactNode } from "react";

import { faXmark } from "@fortawesome/pro-solid-svg-icons/faXmark";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import cn from "classnames";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import { StandardStepProps } from "@app/component/wizard/components/StandardStep";

import commonStyles from "./CommonStepStyles.module.scss";
import styles from "./StepWithImage.module.scss";

interface StepWithImageProps extends StandardStepProps {
  image: ReactNode;
}

const StepWithImage = ({
  backButtonDisabled,
  backButtonHidden,
  backButtonProps,
  backButtonText,
  canClose = true,
  children,
  className,
  containerClassName,
  footer,
  image,
  nextButtonDisabled,
  nextButtonHidden,
  nextButtonProps,
  nextButtonText,
  nextButtonTooltipProps,
  onCancel,
  onGoBack,
  onGoForward,
  showHeader = true,
  title,
}: StepWithImageProps) => {
  const intl = useIntl();

  return (
    <div className={cn(styles.container, containerClassName)}>
      <div className={styles.image}>{image}</div>
      <div className={styles.details}>
        {showHeader && (
          <div className={commonStyles.header}>
            <div className={commonStyles.title}>{title}</div>
            {canClose && (
              <div className={commonStyles.closeIconWrapper}>
                <FontAwesomeIcon
                  className={commonStyles.closeIcon}
                  icon={faXmark}
                  onClick={onCancel}
                />
              </div>
            )}
          </div>
        )}
        <div className={cn(commonStyles.content, className)}>{children}</div>
        {footer === undefined ? (
          <div className={commonStyles.footer}>
            <div>
              <Button
                disabled={backButtonDisabled}
                hidden={backButtonHidden}
                onClick={onGoBack}
                {...backButtonProps}
              >
                {backButtonText ||
                  intl.formatMessage({
                    id: "wizard.standardStep.footer.back",
                    defaultMessage: "Go Back",
                    description: "Back button title in a StandardStep of a Wizard component",
                  })}
              </Button>
            </div>
            <div>
              <Tooltip {...nextButtonTooltipProps}>
                <Button
                  disabled={nextButtonDisabled}
                  hidden={nextButtonHidden}
                  onClick={onGoForward}
                  type="primary"
                  {...nextButtonProps}
                >
                  {nextButtonText ||
                    intl.formatMessage({
                      id: "wizard.standardStep.footer.next",
                      defaultMessage: "Next",
                      description: "Next button title in a StandardStep of a Wizard component",
                    })}
                </Button>
              </Tooltip>
            </div>
          </div>
        ) : (
          footer
        )}
      </div>
    </div>
  );
};

export default StepWithImage;
